import React from 'react';
import "./CopyToast.scss";

import { ReactComponent as CopyIcon } from "static/icons/copy-icon.svg";

const CopyToast = () => {
  return (
    <div className="copy-toast">
      <div className="copy-toast__icon-container">
        <CopyIcon className="copy-toast__icon" />
      </div>

      <div className="copy-toast__text">
        Copied to clipboard
      </div>
    </div>
  );
};

export default CopyToast;
